import { SCREEN } from "helper/roleChecker/Screens";
import { lazy } from "react";

import pathRoutes from "routes/pathRoutes";

const MainPage = lazy(() => import("./Pages/Main"));

export const declareLeaveRoutes = [
  {
    page: MainPage,
    path: pathRoutes.declareLeave.base,
    screenCode: SCREEN.IP_015,
  },
  {
    page: MainPage,
    path: pathRoutes.declareLeave.parameter,
    screenCode: SCREEN.IP_015,
  },
  {
    page: MainPage,
    path: pathRoutes.declareLeave.list.parameter,
    screenCode: SCREEN.IP_015,
  },
  {
    page: MainPage,
    path: pathRoutes.declareLeave.detail.parameter,
    screenCode: SCREEN.IP_015,
  },
];
